import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  headerSpace: {
    flexDirection: 'column',
    backgroundColor: 'rgba(240, 244, 248, 0.875);\n',
    height: 50,
    marginRight: 20,
    marginLeft: 20,
    marginTop: 10,
    borderRadius: 10,
    justifyContent: 'center'
  },
  headerText: {
    color: 'rgba(29, 92, 66, 1)',
    fontSize: 16,
    marginLeft: 20,
    textTransform:'uppercase'
  },
});
